function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-193e156b\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?sourceMap!./bundleProductPreview.styl")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./bundleProductPreview.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-193e156b\",\"hasScoped\":true}!./bundleProductPreview.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-193e156b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/bundleProductPreview/bundleProductPreview.vue
// module id = 2684
// module chunks = 1